<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    icons: {
      type: Object,
      required: true,
    },
    size: {
      type: [String, Number],
      default: '20',
    },
    type: {
      type: String,
      default: 'outline',
    },
    viewBox: {
      type: String,
      default: '0 0 24 24',
    },
    iconLib: {
      type: String,
      default: 'fluent',
    },
  },

  computed: {
    iconKey() {
      return `${this.icon}-${this.type}`;
    },
    pathSource() {
      const path = this.icons[this.iconKey];
      if (!path) {
        const fallback = this.icons['link-outline'];
        if (!fallback) {
          console.warn(`Fluent icon "${this.iconKey}" is missing and no fallback was found.`);
          return [];
        }
        console.warn(`Fluent icon "${this.iconKey}" is missing. Falling back to "link-outline".`);
        return Array.isArray(fallback) ? fallback : [fallback];
      }
      return Array.isArray(path) ? path : [path];
    },
  },
};
</script>

<template>
  <svg
    v-if="iconLib === 'fluent'"
    :width="size"
    :height="size"
    fill="none"
    :viewBox="viewBox"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      v-for="source in pathSource"
      :key="source"
      :d="source"
      fill="currentColor"
    />
  </svg>
  <svg
    v-else
    :width="size"
    :height="size"
    fill="none"
    :viewBox="viewBox"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g v-for="(pathData, index) in pathSource" :key="index">
      <path
        :key="pathData"
        :d="pathData"
        stroke="currentColor"
        stroke-width="1.66667"
      />
    </g>
  </svg>
</template>
